import { useEffect, useRef } from 'react';
import { toast } from 'sonner';
import { metrics } from './editorCatalog';
import { invertible } from './quickActions';

const light = hex => { const n = parseInt((hex || '#000000').slice(1), 16); return (.2126 * (n >> 16 & 255) + .7152 * (n >> 8 & 255) + .0722 * (n & 255)) / 255 > .55; };

// Light engraving (glass, dark anodised metal) turns dark photo areas bright: offer the one-tap swap once per photo.
export function useInvertHint(editor, admin) {
  const seen = useRef(null);
  useEffect(() => {
    const photos = editor.allObjects.filter(o => o.type === 'image' && o.assetId && !o.placeholder);
    if (seen.current === null) { seen.current = new Set(photos.map(o => o.id)); return; }
    if (admin || !invertible(editor) || !light(metrics.ink)) return;
    photos.filter(o => !seen.current.has(o.id)).forEach(o => {
      seen.current.add(o.id);
      if (o.aiGenerated || o.inkArt || o.invert || (o.effect && o.effect !== 'none')) return;
      toast('Wirkt dein Foto wie ein Negativ?', { id: `invert-${o.id}`, duration: 9000, description: 'Auf diesem Material wird die Gravur hell. Mit „Invertieren“ tauschst du Hell und Dunkel.', action: { label: 'Invertieren', onClick: () => editor.patchObject(o.id, { invert: true }) } });
    });
  }, [editor.allObjects]); // eslint-disable-line react-hooks/exhaustive-deps
}
